/**
 * Chip — `Oprappo Design System.dc.html § 03 কাঠামো · ট্যাব · চিপ · ব্যাজ`, middle third.
 *
 * Frame note: "Chips are pills because they are removable; badges are square because
 * they are not."
 *
 * Selected: `background:#0E3A45; color:#fff; padding:8px 13px; 500 14px/1.75; radius 999px`.
 * Default:  `border:1px solid #E2DED5; color:#1A2422;` same box, same radius.
 *
 * Note the padding here is `8px 13px` while § 03's filter chip is `7px 11px` and the
 * § 06 inline buttons are `10px 14px`. All three are transcribed as drawn, not unified.
 */
import { cx } from './internal/cx.js';

export interface ChipProps {
  /** Bangla label, e.g. `কাছাকাছি`, `৳ ৫০০-র নিচে`. */
  labelBn: string;
  selected?: boolean | undefined;
  onClick?: (() => void) | undefined;
  className?: string | undefined;
}

export function Chip({ labelBn, selected = false, onClick, className }: ChipProps): JSX.Element {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={cx(
        'inline-flex items-center px-[13px] py-[8px] font-anek font-medium text-[14px] leading-[1.75] rounded-pill',
        selected ? 'bg-teal text-white border-0' : 'border border-border text-ink2 bg-transparent',
        className,
      )}
    >
      {labelBn}
    </button>
  );
}
